import React from "react";
import "./withCard.scss";

const WithCard = ({ children }) => {
  return <div className="with-card">{children}</div>;
};

export default WithCard;



// WEBPACK FOOTER //
// ./src/components/common/withCard/withCard.jsx